export function getOrigin() {
  const localHost = "http://test.local:8081",
    testHost = "http://imyoa.mmzqoa.net:30443";

  return window.location.origin === localHost
    ? localHost || testHost
    : window.location.origin;
}

export function getAuthHost() {
  const isLocal = location.href.includes('test.local')
  const isDev = location.href.includes('imyoa.mmzqoa.net')

  return (isLocal || isDev) ? 'https://iauth.mmzqoa.net:30443' : 'https://auth.mmzqoa.net'
}
